import localAxios from '../localAxios';
import { teamInviteInfoUrl } from './urls';

interface TeamInviteInfoResponse {
  email: string;
  teamId: string;
  role: string;
  inviterId: string;
  inviterName: string;
}

export async function getTeamInviteInfo(inviteCode: string) {
  const url = teamInviteInfoUrl({ inviteCode });
  try {
    const { data } = await localAxios.get<TeamInviteInfoResponse>(
      url.toString()
    );
    return {
      ...data,
    };
  } catch (error) {
    throw new Error(error);
  }
}
